import { AnimatePresence } from 'motion/react';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useThemeValues } from '../../../hooks';
import { ModalBackdrop } from '../atoms';
import { ModalProps } from '../modal.types';
import { ModalProvider, useModalAppConfigContext } from '../provider';
import { ResponsiveModalBody } from './responsive-modal-body';
import { ResponsiveModalProvider } from './responsive-modal.context';

type ResponsiveModalProps = ModalProps & { topOffset?: number };

export const ResponsiveModal = ({
  minWidth = 0,
  maxWidth = 400,
  topOffset: topOffsetProp,
  disableCloseOnOverlayClick,
  disableCloseOnEscape,
  show,
  zIndex: overrideZIndex,
  ...props
}: ResponsiveModalProps) => {
  const { onClose, mountTarget, prepend } = props;
  const isMobile = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const { topOffset: topOffsetContext } = useModalAppConfigContext() ?? {};
  const topOffset = topOffsetProp ?? topOffsetContext ?? 0;
  const { zIndex } = useThemeValues();

  return (
    <ResponsiveModalProvider variant={isMobile ? 'fullscreenModal' : 'modal'} topOffset={topOffset}>
      <AnimatePresence>
        {show && (
          <ModalProvider
            className='wv-modal-container'
            onClose={onClose}
            timeout={500}
            disableCloseOnEscape={disableCloseOnEscape}
            mountTarget={mountTarget}
            prepend={prepend}
            show={show}
            containerAttributes={{
              style: overrideZIndex ? `z-index: ${overrideZIndex};` : undefined,
            }}
          >
            <ModalBackdrop
              onClick={disableCloseOnOverlayClick ? undefined : onClose}
              show={show}
              omitOffset={!!mountTarget}
              zIndex={isMobile ? zIndex.modals : undefined}
            />
            <ResponsiveModalBody {...props} minWidth={minWidth} maxWidth={maxWidth} flex />
          </ModalProvider>
        )}
      </AnimatePresence>
    </ResponsiveModalProvider>
  );
};
